module.exports = __webpack_public_path__ + "img/chemistry.3c0e7047.png";